<template>
  <div id="FiltrosDeBusqueda_div">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
      <h5>{{tituloDeBusqueda}}</h5>
      <button v-if="accionCancelar != null || accionCancelar != undefined" class="btn-sm btn-primary btn-buscar" id="realizarFiltrosBusqueda_btn_cancelar" @click='accionCancelar.funcion'><i class="fas fa-window-close"></i></button>
    </div>
    <hr class="mt-1" />    
    <div class="row">


      <div class="col-12 form-group" id="seleccione_div">     
          <h6>Ingrese o seleccione al menos una de las siguientes entradas:</h6>
     </div>


     <div class="col-12 form-group" id="select-reporte" >
        <h6>Tipo de reporte</h6>
        <select v-model="TipoReporte" class="form-control" @change="eventoCambioTipoDeReporte">
        <option value="0">Seleccione el tipo de reporte</option>
        <option value="1">Bitácora de movimientos realizados por periodo de fecha</option>
        <option value="2">Bitácora de movimientos realizados por semana actual</option>
        <option value="3">Bitácora de movimientos realizados por semana anterior</option>
        <option value="4">Bitácora de movimientos realizados por historial</option>
       </select>
       </div> 



    <div v-for="catalogo in catalogos" :key="catalogo.catalogoId" class="col-12 p-0 m-0 form-group">     
      <div v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null">

        
        <div  v-if="catalogo.catalogoId == enumeraciones.catalogos.Movimientos" id="Movimiento_div" class="pr-3 pl-3 pt-1 pb-3">
          <h6>Tipo de movimiento</h6>
          <C016TiposMovimientos
            
          v-on:valorParaElPadre="cambioTipoEstatusMovimiento" 
          v-on:valorParaElPadrePrimerElemento="cambioDeEstatus" 
          :prefijo="catalogo.etiquetaDeHtml" 
          :tipo="catalogo.tipoDeSelect" 
          :idDelInput="catalogo.idDelInput" 
          :parametros="parametros_TipoMovimiento.parametros" 
          :valorDefinido="parametros_TipoMovimiento.tipoMovimientoId" 
          :key="parametros_TipoMovimiento.key">
          </C016TiposMovimientos>
        </div>


        <div v-show="(catalogo.catalogoId == enumeraciones.catalogos.FechaDeInicio) && (TipoReporte== 1)
        " id="FechaDeInicio_div" class="pr-3 pl-3 pt-1 pb-3">
          <h6 for="fechaInicial">Fecha inicial</h6>
          <input type="date" id="fechaInicial" v-model="fechaInicial" @change="A_Comun_FechaInicial(fechaInicial)" class="form-control" 
          :max="fechaFinalMaxima" />
        </div>

        

        <div  v-show="(catalogo.catalogoId == enumeraciones.catalogos.FechaFinal) && (TipoReporte== 1)
        " id="FechaFinal_div" class="pr-3 pl-3 pt-1 pb-3">
          <h6 for="fechaFinal">Fecha final</h6>
          <input type="date" id="fechaFinal" v-model="fechaFinal" @change="A_Comun_FechaFinal(fechaFinal)" class="form-control" 
          :max="fechaFinalMaxima" />
        </div>


        
        </div>

        </div>


        
        
 




          
    <div class="col-12 form-group" id="nombre_div">     
          <h6>Nombre(s)</h6>
          <input class="form-control" type="text" placeholder="Ingrese el nombre" v-model="nombre" id="nombre"
          @input="(text) => (nombre = nombre.toUpperCase())" @keypress="esLetra($event)" />
    </div>
    <div class="col-12 form-group" id="apellido_paterno_div">
          <h6>Apellido Paterno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido paterno" v-model="apellido_paterno" id="apellido_paterno"
          @input="(text) => (apellido_paterno = apellido_paterno.toUpperCase())" @keypress="esLetra($event)" />
    </div>
    <div class="col-12 form-group" id="apellido_materno_div">
          <h6>Apellido Materno</h6>
          <input class="form-control" type="text" placeholder="Ingrese el apellido materno" v-model="apellido_materno" id="apellido_materno"
          @input="(text) => (apellido_materno = apellido_materno.toUpperCase())" @keypress="esLetra($event)" />
    </div>
    <div class="col-12 form-group" id="clave_del_procesado_div">
          <h6>Clave del Procesado</h6>
          <input class="form-control" type="text" placeholder="Ingrese la clave del procesado" v-model="clave_del_procesado" id="clave_del_procesado" v-mask="'######'" />
    </div>

    <div class="d-flex" style="height: 100px;">
    <div class="vr"></div>
    </div>




    </div>
    
    <hr class="mt-1" />
    <div id="RealizarFiltrosBusqueda_div" class="d-flex row">
      <div class="col-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7 pb-2 text-left">          
          <button class="btn btn-primary overwrapDeBotones p-2 btn-buscar" @click="limpiarFiltros();"><i class="fas fa-eraser fa-lg"></i>&nbsp;&nbsp;Limpiar Formulario</button>
      </div> 
      <div class="col-12 col-sm-12 col-md-5 col-lg-5 col-xlg-5 mb-1 pb-1 text-right">


          <button type="button" v-if="(camposLlenos()) && (TipoReporte== 1)"  class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>


          <button type="button" v-if="(TipoReporte== 2)"  class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion2()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>

          

          <button type="button" v-if="(TipoReporte== 3)"  class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion3()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>



          <button type="button" v-if="(TipoReporte== 4)"  class="btn btn-primary overwrapDeBotones mb-1 p-2 btn-buscar" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion4()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>





      </div> 
      
    </div>    
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import comun from "@/../static/js/comun"
  import { mapActions } from 'vuex'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
  import VueMask from 'v-mask'
  import axios from 'axios'
  import api from '@/../static/js/api'
  import func from './Funciones/comun.js'

  Vue.use(VueMask);

  export default {
    directives: {
        tooltipF
    },
    data() {
      return {
        enumeraciones,
        consecutivo: "",
        numeroExtra: '',  
        numeroCarpeta: null, 
        fechaInicial: moment().startOf('month').format('YYYY-MM-DD'),
        fechaFinal: moment().format('YYYY-MM-DD'),
        mostrarNumeroExtra: false,
        fechaFinalMaxima: new Date().toISOString().split('T')[0],     
        
        
        parametros_TipoMovimiento: {
          key: "",
          tipoMovimientoId: -1,
          parametros: {},
          esInformativo: false
        },
        folioAcuerdo: null,
        nombre: null,
       
        apellido_paterno: null,
        apellido_materno: null,
        clave_del_procesado: null,
        TipoReporte: 0,
        titulosdelreporte: {
          1: 'Reporte de bitácora de movimientos realizados del:',
          2: 'Reporte de bitácora de movimientos realizados en la semana actual del:',
          3: 'Reporte de bitácora de movimientos realizados en la semana anterior del:',
          4: 'Reporte de bitácora de movimientos realizados por historial'
        }        
      }
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C008Delitos: catalogos.PJ.C008Delitos,
      C016TiposMovimientos: catalogos.SIVAC.C016TiposMovimientos,
    },
    props: {
      tituloDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: Object,
      elementosAConservar: Object,
      ejecutaLaFuncion: Function,
      ejecutaLaFuncion2: Function,
      ejecutaLaFuncion3: Function,
      ejecutaLaFuncion4: Function,
      ejecutalimpiarTablaResultados: Function,
      filtrosEstablecidos: Object,
      buscar: true,
      accionCancelar: {
        default: null,
        type: Object
      },
      AccionesMostrar:{            
        firma: false,
        pagos: false          
      },
      area: null
    },
    mounted() {            
      // if(this.elementosAOmitir){
      //   if(this.elementosAOmitir.areas && this.elementosAOmitir.areas.length > 0){
      //     this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
      //     this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
      //   }
      //   if(this.elementosAOmitir.materias && this.elementosAOmitir.materias.length > 0){
      //     this.parametros_Materia.parametros.elementosAOmitir = this.elementosAOmitir.materias;
      //     this.parametros_Materia.key = "elementosOmitir_" + this.elementosAOmitir.materias.length;
      //   }
      // }          
      
      /*this.parametros_Area.parametros.SistemaId = 38;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true; */
    },
    beforeMount()
    {
      // if(this.area != undefined && this.area != null)
      // {
      //   this.parametros_PartidoJudicial.parametros.AreaId = this.area.AreaId;
      //   this.parametros_Area.parametros.AreaId = this.area.AreaId;
      //   this.parametros_Materia.parametros.AreaId = this.area.AreaId;
      //   this.parametros_Area.parametros.conInactivos = true;
      // }
      // else{
      //   this.parametros_TipoDocumento.parametros.elementosAConservar = [1,2,10,16,23,24];
      // }

      // if(this.elementosAConservar){        
      //   if(this.elementosAConservar.areas && this.elementosAConservar.areas.length > 0){
      //     this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
      //     this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
      //   }
      // }
    },
    created() {
      // this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);

      this.$store.dispatch('A_Comun_FechaInicial', this.fechaInicial);
      this.$store.dispatch('A_Comun_FechaFinal', this.fechaFinal);          
    },
    methods: {

      eventoCambioTipoDeReporte: function() {

        this.$emit('emitGetTipoReporte', this.titulosdelreporte[parseInt(this.TipoReporte)]);
      },

      
      /**
       * Método encargado de limpiar los filtros de los combos del formulario.
       */
      limpiarFiltros: function(){


        this.parametros_TipoMovimiento.tipoMovimientoId = -1;
        this.parametros_TipoMovimiento.key += 1;

        this.numeroExtra = null;
        this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);
        this.consecutivo = null;             
        this.numeroCarpeta = null; 
        
        this.nombre = null;
        this.apellido_paterno = null;
        this.apellido_materno = null;
        this.clave_del_procesado= null;


        this.fechaInicial= moment().startOf('month').format('YYYY-MM-DD');
        this.fechaFinal= moment().format('YYYY-MM-DD');

        // this.fechaInicial = null;
        // this.fechaFinal=null;


        this.TipoReporte= 0;


        


        

        this.esAreaDeEjecucion = false;     
      },



           /** 
       * Metodo encargado de verificar que todos los campos requeridos estén llenos
       * @param {object} evento [evento emitido por el catalogo]
       */
      camposLlenos:function()
      {
        


        // if (!this.parametros_TipoMovimiento.tipoMovimientoId || this.parametros_TipoMovimiento.tipoMovimientoId <= 0) 
        //   return false;


        if (!this.TipoReporte || this.TipoReporte <= 0) 
          return false;



        // if (!this.nombre || this.nombre <= 0) 
        //   return false;

        // if ((!this.apellido_paterno || this.apellido_paterno <= 0) && (!this.apellido_materno || this.apellido_materno <= 0)) 
        //    return false; 

        if (!this.fechaInicial || this.fechaInicial <= 0) 
          return false;

        if (!this.fechaFinal || this.fechaFinal <= 0) 
          return false;



        
        return true;
      }, 


      


      /**
       * Método encargado de actualizar/cambiar el campo TipoEstatus
       * @param {event.target} datos [datos: nuevo valor del TipoEstatus]
       */
      cambioTipoEstatusMovimiento(datos){
        this.cambioDeEstatus(parseInt(datos.target.value));
      },
      /**
       * Método encargado de actualizar/cambiar el id de TipoEstatus
       * @param {int} id [id: identificador del TipoEstatus]
       */
      cambioDeEstatus(id){
        this.parametros_TipoMovimiento.tipoMovimientoId = id; 
      },


      esLetra(datos){
        return func.esLetra(datos)
      },

      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Consecutivo'


      ])


    }
  }
</script>
<style scoped>
  #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
  }
  .catalogoInformativo {
      pointer-events:none;
      cursor: not-allowed;
      opacity: 0.5;
  }
  ul { 
    list-style: none;
  }
  .btn-buscar{
    background-color: var(--gris-pj);
  }
  </style>



// WEBPACK FOOTER //
// src/components/SIVAC/Comun/FiltroReportesDeBitacoraDeMovimientosRealizados.vue